import { Device } from 'modules/Device/Device'
import { Model } from 'pinia-orm'

import { Attr, BelongsTo, Uid } from 'pinia-orm/dist/decorators'

export default class MissingDeviceHistory extends Model {
  static override entity = 'missing_device_histories'

  // Fields
  @Uid() declare id: string

  @Attr() declare missing_index: number

  @Attr() declare device_id: string
  @Attr() declare tenant_id: string
  @Attr() declare org_id: string

  // Relationships
  @BelongsTo(() => Device, 'device_id') declare device: Device | null
}
